"use strict";

import Vue from 'vue';

const eventBus = new Vue();
const eventAlias = "loading";

export default {
  showLoading (show) {
    eventBus.$emit(eventAlias, show);
  },
  onLoading (onLoading) {
    eventBus.$on(eventAlias, onLoading);
  }
};



// WEBPACK FOOTER //
// ./src/services/loadingService.js